export const Svg_111 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="m31.938 39.885 15.458-15.458-3.135-3.062L31.913 33.76l-6.173-6.197-3.136 3.062 9.334 9.26ZM2.917 61.25v-4.375h64.166v4.375H2.918Zm7.292-8.75c-1.167 0-2.188-.438-3.063-1.313-.875-.874-1.312-1.895-1.312-3.062v-35c0-1.167.437-2.188 1.312-3.063.875-.874 1.896-1.312 3.063-1.312h49.583c1.166 0 2.187.438 3.062 1.313.875.874 1.313 1.895 1.313 3.062v35c0 1.167-.438 2.188-1.313 3.063-.875.874-1.895 1.312-3.062 1.312H10.208Zm0-4.375h49.583v-35H10.208v35Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={17.755}
        x2={40.21}
        y1={16.625}
        y2={61.041}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)